/**
 * The German sentence for who is typing: „Anna schreibt …“, „Anna und Ben
 * schreiben …“, „Anna und 3 weitere schreiben …“. Empty names are skipped;
 * no names give an empty string.
 */
export function formatTypingNames(names: readonly string[]): string {
  const list = names.map((n) => n.trim()).filter(Boolean);
  if (list.length === 0) return '';
  if (list.length === 1) return `${list[0]} schreibt …`;
  if (list.length === 2) return `${list[0]} und ${list[1]} schreiben …`;
  return `${list[0]} und ${list.length - 1} weitere schreiben …`;
}
